import AddIcon from "@mui/icons-material/AddRounded";
import { Button } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import useFetch from "@entrilia/shared/hooks/useFetch";
import adminApi from "../../../../api/adminApi";
import useClientContext from "../../../../context/useClientContext";
import AddContactDialog from "../common/AddContactDialog";

const ContactsActionsToolbar = () => {
  const { hasAnyPermission } = useClientContext();
  const navigate = useNavigate();
  const [isAddContactDialogOpen, setIsAddContactDialogOpen] = useState(false);

  const getAllContacts = useCallback(
    () => adminApi.searchContacts({ fieldIds: [], includeFundInvestors: false, includeInboxData: false }),
    []
  );

  const [allContactsResp] = useFetch(getAllContacts, { disabled: !isAddContactDialogOpen });

  const { existingContactNames, existingContactEmails } = useMemo(() => {
    const existingContactNames = new Set<string>((allContactsResp?.items ?? []).map((c) => c.name));
    const existingContactEmails = new Set<string>((allContactsResp?.items ?? []).map((c) => c.email.toLowerCase()));
    return { existingContactNames, existingContactEmails };
  }, [allContactsResp?.items]);

  const hasAccessToManage = hasAnyPermission(["ManageFundStructure"]);

  return (
    <>
      {hasAccessToManage && (
        <Button
          sx={{ whiteSpace: "nowrap" }}
          onClick={() => setIsAddContactDialogOpen(true)}
          variant="contained"
          startIcon={<AddIcon />}
        >
          New Contact
        </Button>
      )}

      {isAddContactDialogOpen && (
        <AddContactDialog
          mode="create"
          onClose={() => setIsAddContactDialogOpen(false)}
          onCreate={(contact) => {
            navigate(`./${contact.id}/main`);
          }}
          existingContactNames={existingContactNames}
          existingContactEmails={existingContactEmails}
        />
      )}
    </>
  );
};

export default ContactsActionsToolbar;
